import { createContext, useContext, useEffect, useRef, useState, useCallback } from 'react';
import api from '../api';
import { useAuth } from './AuthContext';

const BackgroundJobsContext = createContext({ jobs: [], runningCount: 0, refresh: () => {} });

export const useBackgroundJobs = () => useContext(BackgroundJobsContext);

export function BackgroundJobsProvider({ children }) {
  const { user } = useAuth();
  const [jobs, setJobs]     = useState([]);
  const [toasts, setToasts] = useState([]);
  const prevRunning = useRef(new Set());
  const timerRef    = useRef(null);

  const refresh = useCallback(async () => {
    try {
      const res  = await api.get('/api/background-jobs');
      const data = Array.isArray(res.data) ? res.data : [];

      // Detecteer taken die net van 'running' naar afgerond zijn gegaan → melding
      const nowRunning = new Set(data.filter(j => j.status === 'running').map(j => j.id));
      prevRunning.current.forEach(id => {
        if (!nowRunning.has(id)) {
          const j = data.find(x => x.id === id);
          if (j && j.status !== 'running' && j.status !== 'interrupted') {
            const toast = { id: `${id}-${Date.now()}`, job: j };
            setToasts(t => [...t, toast]);
            setTimeout(() => setToasts(t => t.filter(x => x.id !== toast.id)), 9000);
          }
        }
      });
      prevRunning.current = nowRunning;
      setJobs(data);
    } catch {
      /* stil — geen netwerk of niet ingelogd */
    }
  }, []);

  useEffect(() => {
    if (!user) {
      setJobs([]);
      prevRunning.current = new Set();
      if (timerRef.current) clearInterval(timerRef.current);
      return;
    }
    refresh();
    timerRef.current = setInterval(refresh, 5000);
    return () => { if (timerRef.current) clearInterval(timerRef.current); };
  }, [user, refresh]);

  const runningCount = jobs.filter(j => j.status === 'running').length;

  const dismiss = (id) => setToasts(t => t.filter(x => x.id !== id));

  return (
    <BackgroundJobsContext.Provider value={{ jobs, runningCount, refresh }}>
      {children}
      <div style={{ position: 'fixed', bottom: 16, right: 16, zIndex: 2000, display: 'flex', flexDirection: 'column', gap: 8 }}>
        {toasts.map(tt => (
          <div
            key={tt.id}
            className={`alert ${tt.job.errors > 0 ? 'alert-warning' : 'alert-success'} shadow-sm mb-0 d-flex align-items-start`}
            style={{ minWidth: 300, maxWidth: 380 }}
          >
            <span className="me-2">✨</span>
            <div className="flex-grow-1 small">
              <strong>{tt.job.status === 'stopped' ? 'Polish gestopt' : 'Polish klaar'}</strong>
              {tt.job.audit_name ? ` — ${tt.job.audit_name}` : ''}
              <div className="text-muted">
                {tt.job.polished} verwerkt
                {tt.job.errors > 0 ? `, ${tt.job.errors} fout` : ''}
              </div>
            </div>
            <button type="button" className="btn-close ms-2" onClick={() => dismiss(tt.id)} />
          </div>
        ))}
      </div>
    </BackgroundJobsContext.Provider>
  );
}
